import { fromSatoshi, toSatoshi } from "../lib/utils";
function sumFees(fees) {
    return Object.values(fees).reduce((reducer, fee) => reducer + fee, 0n);
}
/**
 * Module exposing general functions related to the Acre protocol.
 */
export default class Protocol {
    /**
     * Acre contracts.
     */
    #contracts;
    constructor(contracts) {
        this.#contracts = contracts;
    }
    /**
     * @returns Total Bitcoin amount under protocol management in 1e8 satoshi
     *          precision.
     */
    async totalAssets() {
        return toSatoshi(await this.#contracts.stBTC.totalAssets());
    }
    /**
     * Estimates the deposit fee based on the provided amount.
     * @param amount Amount to deposit in satoshi.
     * @returns Deposit fee grouped by tBTC and Acre protocols in 1e8 satoshi
     *          precision and total deposit fee value.
     */
    async estimateDepositFee(amount) {
        const amountInTokenPrecision = fromSatoshi(amount);
        const { acre: acreFees, tbtc: tbtcFees } = await this.#contracts.bitcoinDepositor.calculateDepositFee(amountInTokenPrecision);
        const depositFee = await this.#contracts.stBTC.calculateDepositFee(amountInTokenPrecision);
        const tbtc = toSatoshi(sumFees(tbtcFees));
        const acre = toSatoshi(sumFees(acreFees)) + toSatoshi(depositFee);
        return {
            tbtc,
            acre,
            total: tbtc + acre,
        };
    }
    /**
     * Estimates the withdrawal fee based on the provided amount.
     * @param amount Amount to withdraw in satoshi.
     * @returns Withdrawal fee grouped by tBTC and Acre protocols in 1e8 satoshi
     *          precision and total withdrawal fee value.
     */
    async estimateWithdrawalFee(amount) {
        const amountInTokenPrecision = fromSatoshi(amount);
        const { tbtc: tbtcFees } = await this.#contracts.bitcoinRedeemer.calculateWithdrawalFee(amountInTokenPrecision);
        const withdrawalFee = await this.#contracts.stBTC.calculateWithdrawalFee(amountInTokenPrecision);
        const tbtc = toSatoshi(sumFees(tbtcFees));
        const acre = toSatoshi(withdrawalFee);
        return {
            tbtc,
            acre,
            total: tbtc + acre,
        };
    }
    /**
     * @returns Minimum deposit amount in 1e8 satoshi precision.
     */
    async minimumDepositAmount() {
        const value = await this.#contracts.bitcoinDepositor.minDepositAmount();
        return toSatoshi(value);
    }
}
//# sourceMappingURL=protocol.js.map